module.exports = __webpack_public_path__ + "img/Food Contact mark.36b1e7db.png";